__turbopack_context__.v({
  "modalBody": "_7YM8OW_modalBody",
  "modalContent": "_7YM8OW_modalContent",
  "modalFooter": "_7YM8OW_modalFooter",
  "modalHeader": "_7YM8OW_modalHeader",
});
